// components/pages/LoginPage.js - Página de login con estilo Falcon React
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loading from '../common/Loading';
import LoginForm from '../authentication/LoginForm';
import AuthSplitLayout from '../../layouts/AuthSplitLayout';
import Flex from '../common/Flex';
import bgImg from '../../assets/img/galaxymetrics/background.png';

const LoginPage = () => {
  const { authenticated, loading } = useAuth();

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return <Loading fullscreen message="Verificando autenticación..." />;
  }

  // Redirigir al dashboard si ya está autenticado
  if (authenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthSplitLayout bgProps={{ 
      image: bgImg, 
      position: 'center center',
      overlay: true,
      opacity: 0.8
    }}>
      <Flex alignItems="center" justifyContent="between" className="mb-3">
        <h3 className="mb-0">Iniciar sesión</h3>
      </Flex>
      
      <LoginForm layout="split" hasLabel />
    </AuthSplitLayout>
  );
};

export default LoginPage; 